import script from "./DebugRequestPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./DebugRequestPanel.vue?vue&type=script&setup=true&lang=js"

import "./DebugRequestPanel.vue?vue&type=style&index=0&id=41d46136&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41d46136"]])

export default __exports__